import { requestBuilder } from '../../http/RequestBuilder';
import type { CombinedStatement } from '../types/Statement';

const useGetAllStatements = requestBuilder.query<
    CombinedStatement[],
    { userId: string }
>({
    endpoint: ({ userId }) => `/api/bank-accounts/user/${userId}/statements`,
    queryKey: ({ userId }) => `getAllStatements/${userId}`,
});

export default useGetAllStatements;
